import { combineReducers } from "redux";

import legacyInvitations from "./legacyInvitationReducer";
import teammateInvitations from "./teammateInvitationReducer";

export default combineReducers({
  legacyInvitations,
  teammateInvitations
});
